$(document).ready(function(){
    // delete confirm dialog
    $('#confirmdelete').on('show.bs.modal', function (e) {
        var modal = $('#confirmdelete');
        var $invoker = $(e.relatedTarget);
        var url = $invoker.attr('rel');
        var confirm = modal.find('#modal_commlog_confirm_delete');
        confirm.click(function(){
          window.location = url;
          // window.location.reload(true);
        });
    });
    $('#addcommlog').on('show.bs.modal', function (e) {
        if (e.target.id == 'addcommlog') {

            var modal = $('#addcommlog')
            var $invoker = $(e.relatedTarget)
            var id = $invoker.attr('rel')

            // set to blank defaults for form re-use
            modal.find('#form_modal_notes').text('')
            modal.find("#reason_id").val(0)
            modal.find("#status_id").val(0)
            modal.find("#channel_id").empty()
  
            if (id) {
                modal.find('form').attr('action','/participants/editcommlog/' + 0 )
                modal.find('#addedit').text('Edit')

                var json = $.get('/participants/json_commlog/' + id, function(data) {
                    var comm = JSON.parse(data)
                    modal.find("#channel_fieldset").prop('disabled', false)
                    modal.find("#recipient").val(comm.recipient)
                    $.each(comm.channels, function(idx, item) {
                        $('#channel_id').append($('<option>', { 
                            value: item.channel_id,
                            text : item.address +' ('+ item.name +')'
                        }))
                    })
                    var logDate = moment(comm.date).format('YYYY-MM-DD')
                    var logTime = moment(comm.date).format('h:mm a')

                    modal.find('form').attr('action','/participants/editcommlog/' + comm.id)
                    modal.find('#form_modal_notes').text(comm.notes)
                    modal.find("#reason_id").val(comm.comm_reason_id)
                    modal.find("#status_id").val(comm.comm_status_id)
                    modal.find("[name=log_date]").val(logDate)
                    modal.find("[name=log_time]").val(logTime)

                    if (comm.old_channel === true) {
                        modal.find("#channel_id").val("no_change")
                    } else {
                        modal.find("#channel_id").val(comm.channel_id)
                    }
                });
            } else {
                modal.find('form').attr('action','/participants/addcommlog')
                modal.find('#addedit').text('Add')
            }
        }
    });
    
});

